module.exports = __webpack_public_path__ + "img/book_6_zh.e8880ddf.png";